import { render, staticRenderFns } from "./avoidedCosts.vue?vue&type=template&id=36ad7722"
import script from "./avoidedCosts.vue?vue&type=script&lang=js"
export * from "./avoidedCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports